/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetOrdersQueryResponse, GetOrdersQueryParams, GetOrders400 } from "../entities/GetOrders";

function getGetOrdersUrl() {
  const res = { method: 'GET', url: `/orders` as const }  
  return res
}

/**
 * @description Получение списка заказов
 * @summary Получение списка заказов
 * {@link /orders}
 */
export async function getOrders(params: GetOrdersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetOrdersQueryResponse, ResponseErrorConfig<GetOrders400>, unknown>({ method : "GET", url : getGetOrdersUrl().url.toString(), params, ... requestConfig })  
  return res.data
}